// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".animated-arrow-container {\n  min-height: 100px;\n}\n.animated-arrow {\n  -webkit-animation: arrowMove 0.5s ease-in-out infinite alternate;\n  animation: arrowMove 0.5s ease-in-out infinite alternate;\n}\n@-webkit-keyframes arrowMove {\n0% {\n    margin-top: 0;\n}\nto {\n    margin-top: 10px;\n}\n}\n@keyframes arrowMove {\n0% {\n    margin-top: 0;\n}\nto {\n    margin-top: 10px;\n}\n}\n.suggestions .active {\n  background: #eee;\n}\n", ""]);
// Exports
module.exports = exports;
